export function safeStructuredClone(obj) {
    if (typeof structuredClone === 'function') {
        return structuredClone(obj);
    }
    // Fallback implementation, for Chrome < 98 (before 2022)
    return JSON.parse(JSON.stringify(obj));
}
//# sourceMappingURL=structuredClone.js.map